import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/app/app-feedback-type/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/app/app-feedback-type/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/app/app-feedback-type/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/app/app-feedback-type/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/app/app-feedback-type/detail',
    method: 'get',
    params: { id }
  })
}
export function putStatus(data) {
  return request({
    url: '/app/app-feedback-type/status',
    method: 'post',
    data
  })
}
